import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getSignedPdfUrlService = async (fileId) => {
  const apiPath = 'form-editor/signed-url';
  const body = {
    // contentType: 'application/pdf',
    contentType: 'image/jpeg',
    fileId: fileId,
  };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};
